import { SharedModule } from '../../../shared/shared.module';
import { CagnottesDetailsComponent } from './cagnottes-details.component';
import { CagnottesDetailsResolver } from './cagnottes-details.resolver';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';

@NgModule({
  imports: [
    NgbModule,
    SharedModule,
    BsDatepickerModule,
    DataTableModule
  ],
  declarations: [CagnottesDetailsComponent],
  exports: [CagnottesDetailsComponent],
  providers: [CagnottesDetailsResolver]
})
export class CagnottesDetailsModule { }
